import { PaySupplementType } from "@tymbe/legislatives/PaySupplementType"

export const paySupplementTypeNameMap: Record<PaySupplementType, string> = {
  [PaySupplementType.Holiday]: "Příplatek za práci o svátcích",
  [PaySupplementType.Night]: "Příplatek za práci v noci",
  [PaySupplementType.Saturday]: "Příplatek za práci v sobotu",
  [PaySupplementType.Sunday]: "Příplatek za práci v neděli",
}
